// import { Pagination, Form } from "react-bootstrap";

// const DynamicPagination = ({
//   totalPages,
//   currentPage,
//   onPageChange,
//   limitPerPage,
//   onLimitChange,
// }) => {
//   const maxPagesToShow = 5; 
//   const pages = [];

//   const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
//   const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

//   // Ensure we display a consistent number of pages
//   const adjustedStartPage = Math.max(1, endPage - maxPagesToShow + 1);

//   // Add ellipsis if needed before the first page
//   if (adjustedStartPage > 1) {
//     pages.push(
//       <Pagination.Item key={1} onClick={() => onPageChange(1)}>
//         1
//       </Pagination.Item>
//     );
//     if (adjustedStartPage > 2) {
//       pages.push(<Pagination.Ellipsis key="start-ellipsis" />);
//     }
//   }

//   // Add the range of page numbers
//   for (let i = adjustedStartPage; i <= endPage; i++) {
//     pages.push(
//       <Pagination.Item
//         key={i}
//         active={i === currentPage}
//         onClick={() => onPageChange(i)}
//       >
//         {i}
//       </Pagination.Item>
//     );
//   }

//   // Add ellipsis if needed after the last page
//   if (endPage < totalPages) {
//     if (endPage < totalPages - 1) {
//       pages.push(<Pagination.Ellipsis key="end-ellipsis" />);
//     }
//     pages.push(
//       <Pagination.Item
//         key={totalPages}
//         onClick={() => onPageChange(totalPages)}
//       >
//         {totalPages}
//       </Pagination.Item>
//     );
//   }

//   return (
//     <div>
//       <div className="d-flex justify-content-between align-items-center mb-3">
//         <Pagination>
//           <Pagination.First
//             onClick={() => onPageChange(1)}
//             disabled={currentPage === 1}
//           />
//           <Pagination.Prev
//             onClick={() => onPageChange(currentPage - 1)}
//             disabled={currentPage === 1}
//           />
//           {pages}
//           <Pagination.Next
//             onClick={() => onPageChange(currentPage + 1)}
//             disabled={currentPage === totalPages}
//           />
//           <Pagination.Last
//             onClick={() => onPageChange(totalPages)}
//             disabled={currentPage === totalPages}
//           />
//         </Pagination>
//         <Form.Select
//           className="ms-3"
//           value={limitPerPage}
//           onChange={(e) => onLimitChange(Number(e.target.value))}
//           style={{ width: "135px" }}
//         >
//           <option value="5">5 per page</option>
//           <option value="10">10 per page</option>
//           <option value="20">20 per page</option>
//           <option value="50">50 per page</option>
//         </Form.Select>
//       </div>
//     </div>
//   );
// };

// export default DynamicPagination;

import { Pagination, Form } from "react-bootstrap";

const DEFAULT_LIMIT_OPTIONS = [5, 10, 20, 50];

const DynamicPagination = ({
  totalPages,
  currentPage,
  onPageChange,
  limitPerPage,
  onLimitChange,
  limitOptions = DEFAULT_LIMIT_OPTIONS,
}) => {
  const maxPagesToShow = 5;
  const pages = [];

  const startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

  // Ensure we display a consistent number of pages
  const adjustedStartPage = Math.max(1, endPage - maxPagesToShow + 1);

  // Add ellipsis if needed before the first page
  if (adjustedStartPage > 1) {
    pages.push(
      <Pagination.Item key={1} onClick={() => onPageChange(1)}>
        1
      </Pagination.Item>
    );
    if (adjustedStartPage > 2) {
      pages.push(<Pagination.Ellipsis key="start-ellipsis" />);
    }
  }

  // Add the range of page numbers
  for (let i = adjustedStartPage; i <= endPage; i++) {
    pages.push(
      <Pagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => onPageChange(i)}
      >
        {i}
      </Pagination.Item>
    );
  }

  // Add ellipsis if needed after the last page
  if (endPage < totalPages) {
    if (endPage < totalPages - 1) {
      pages.push(<Pagination.Ellipsis key="end-ellipsis" />);
    }
    pages.push(
      <Pagination.Item
        key={totalPages}
        onClick={() => onPageChange(totalPages)}
      >
        {totalPages}
      </Pagination.Item>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Pagination>
          <Pagination.First
            onClick={() => onPageChange(1)}
            disabled={currentPage === 1}
          />
          <Pagination.Prev
            onClick={() => onPageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {pages}
          <Pagination.Next
            onClick={() => onPageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
          <Pagination.Last
            onClick={() => onPageChange(totalPages)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
        <Form.Select
          className="ms-3"
          value={limitPerPage}
          onChange={(e) => onLimitChange(Number(e.target.value))}
          style={{ width: "135px" }}
        >
          {limitOptions.map((opt) => (
            <option key={opt} value={opt}>
              {opt} per page
            </option>
          ))}
        </Form.Select>
      </div>
    </div>
  );
};

export default DynamicPagination;